module.exports = __webpack_public_path__ + "img/loading-icon.4b5efc20.svg";